module.exports = __webpack_public_path__ + "img/103.1ceae92f.png";